import { url } from "./configuration";
import { Store } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import { apihandler } from "./apicaller";

export const loginURL = url + "/v1/user/login";
export const registerURL = url + "/v1/user/register";
export const verifiyUserSession = url + "/v1/user/loginSession?device=web";
export const verifyURL = url + "/v1/user/verify";
export const GetInTouchURL = url + "/v1/user/get-in-touch";
export const ForgotPasswordURL = url + "/v1/user/forgot";
export const resetTokenURL = url + "/v1/user/resetToken";
export const resetPasswordURL = url + "/v1/user/reset";
export const updateRoleURL = url + "/v1/user/updateRole";
export const passwordURL = url + "/v1/user/password";
export const logOutURL = url + "/v1/user/logOut";
export const resendmailURL = url + "/v1/user/resendmail?userId=";
export const updatEmailURL = url + "/v1/user/email";
export const resumeviewURL = url + "/v1/candidate/userview?userId=";
export const publicviewURL = url + "/v1/user/publicview?candidateId=";
export const createResumeURL = url + "/v1/candidate/resume";
export const resumeheadlineURL = url + "/v1/candidate/resumeheadline";
export const getProfileURL = url + "/v1/user/getProfile?userId=";
export const uploadProfileImageURL = url + "/v1/user/profileImage?userId=";
export const updateProfileURL = url + "/v1/user/profile";
export const resumepersonalUpdateURL =
  url + "/v1/candidate/resumepersonaldetail";
export const educationDetailsURL = url + "/v1/candidate/educationDetails";
export const ItSkillsURL = url + "/v1/candidate/itSkills";
export const getresumelistURL = url + "/v1/candidate/resumelist?userId=";
export const employmentDetailsURL = url + "/v1/candidate/employmentDetails";
export const onlineprofileURL = url + "/v1/candidate/onlineprofile";
export const profilesummryURl = url + "/v1/candidate/profileSummary";
export const projectDetailUrl = url + "/v1/candidate/projectdetails";
export const projectlistURL = url + "/v1/employer/projectlist?userId=";
export const empProjectUrl = url + "/v1/employer/project";
export const postBidUrl = url + "/v1/employer/postbid";
export const bidConnectUrl = url + "/v1/employer/bidconnect?id=";
export const projectViewUrl = url + "/v1/user/projectview?candidateId=";
export const getGraphURL = url + "/v1/candidate/graph?userId=";
export const updatResumeStatusURL = url + "/v1/candidate/resume";
export const getBidHistoryURL = url + "/v1/candidate/bid?userId=";
export const contactDetailURL = url + "/v1/candidate/contactdetail";
export const contactDetailDeleteURL = url + "/v1/employer/contactdetail";
export const chatroomURL = url + "/v1/chat/chatroom";
export const chatMessageURL = url + "/v1/chat/chatmessage";
export const AllprojectListURL = url + "/v1/employer/projectsearch";
export const uploadResumeImageURL = url + "/v1/candidate/profileImage?userId=";
export const AllResumeListURL = url + "/v1/candidate/resumesearch";
export const onlinestatusURL = url + "/v1/user/onlinestatus";
export const notificationURL = url + "/v1/user/notification";

export const getDate = (timestamp) => {
  let parseValue = new Date(parseInt(timestamp)).toString();
  let newTime = parseValue.substring(16, 21);

  let returnDate = {
    year: parseValue.substring(11, 15),
    date: parseValue.substring(8, 10),
    month: parseValue.substring(4, 7),
    time:
      newTime.split(":")[0] === "12"
        ? parseInt(newTime.split(":")[0]) +
          ":" +
          newTime.split(":")[1] +
          " " +
          (parseInt(parseInt(newTime.split(":")[0]) / 12) != 1 ? "AM" : "PM")
        : (parseInt(newTime.split(":")[0]) % 12) +
          ":" +
          newTime.split(":")[1] +
          " " +
          (parseInt(parseInt(newTime.split(":")[0]) / 12) != 1 ? "AM" : "PM"),
  };
  return returnDate;
};
// show notification msz
export const showNotificationMsz = (message, messageType, time) => {
  Store.addNotification({
    title: "",
    message: `${message}`,
    type: `${messageType}`,
    insert: "top-center",
    container: "top-center",
    dismiss: {
      duration: time || 3000,
      onScreen: true,
    },
  });
};

export const emailValidator = (email) => {
  const regEx =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!email.match(regEx)) {
    return false;
  }
  return true;
};
export const blankValidator = (validators, key) => {
  if (
    validators === undefined ||
    validators === "" ||
    validators === null ||
    validators == {} ||
    validators === [] ||
    validators == -1 ||
    validators == NaN
  ) {
    return false;
  }
  return true;
};
export const updateOnlineStatus = async (data) => {
  try {
    let payLoad = {
      userId: data.USERLOGIN.user_id,
    };
    apihandler(payLoad, onlinestatusURL, "patch");
  } catch (error) {
    console.log("online stats catch error", error);
  }
};
export const getNotification = async (userId, page) => {
  try {
    const { data, status } = await apihandler(
      {},
      `${notificationURL}?userId=${userId}&page=${page}`,
      "get"
    );
    if (status == 1) {
      return data;
    }
    return [];
  } catch (error) {
    console.log("online stats catch error", error);
  }
};
